import { Stack, TitleGroup } from '@ekhodealer/ekho-common/rev';

import { InventoryForms } from '../inventory-forms/InventoryForms';

import { onboardingContent, OnboardingPage } from './content';

export function InventoryConnectionPage() {
	// Page content
	const pageContent = onboardingContent[OnboardingPage.InventoryConnection];
	return (
		<Stack itemsSpacing='24'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>
			<InventoryForms />
		</Stack>
	);
}
